export const ArNFTEvents = {
  GetToken: 'ArNFTEvents.GetToken',
  TokenReturned: 'ArNFTEvents.TokenReturned',

  GetUnStakedTokens: 'ArNFTEvents.GetUnStakedTokens',
  UnStakedTokensReturned: 'ArNFTEvents.UnStakedTokensReturned',

  GetTokens: 'ArNFTEvents.GetTokens',
  TokensReturned: 'ArNFTEvents.TokensReturned',

  GetBalance: 'ArNFTEvents.GetBalance',
  BalanceReturned: 'ArNFTEvents.BalanceReturned',

  GetCoverStatus: 'ArNFTEvents.GetCoverStatus',
  CoverStatusReturned: 'ArNFTEvents.CoverStatusReturned',

  GetApproved: 'ArNFTEvents.GetApproved',
  GetApprovedReturned: 'ArNFTEvents.GetApprovedReturned',

  Approve: 'ArNFTEvents.Approve',
  ApproveCompleted: 'ArNFTEvents.ApproveCompleted',

  SetApprovalForAll: 'ArNFTEvents.SetApprovalForAll',
  SetApprovalForAllCompleted: 'ArNFTEvents.SetApprovalForAllCompleted',

  GetIsApprovalForAll: 'ArNFTEvents.GetIsApprovedForAll',
  GetIsApprovalForAllReturned: 'ArNFTEvents.GetIsApprovalForAllReturned',

  Claim: 'ArNFTEvents.Claim',
  ClaimCompleted: 'ArNFTEvents.ClaimCompleted',
}
